<template>
    <div>
     <!-- <financing-applying-form-component v-model="financingDetailData"></financing-applying-form-component>
     --> <el-form label-width="170px" class="xzformitemmb">
        <el-row>
          <panel title="贷款申请信息" border>
            <el-col :span="12">
              <el-form-item label="贷款申请编号：">
                {{financingDetailData.fi__applicationNo}}
              </el-form-item>
              <el-form-item label="客户名称：">
                {{financingDetailData.fi__customerName}}
              </el-form-item>
              <el-form-item label="合同编号：">
                {{financingDetailData.ct__contractNo}}
              </el-form-item>
              <el-form-item label="贷款金额：">
                {{financingDetailData.fi__totalAmount|formatMoney}} 元
              </el-form-item>
              <el-form-item label="贷款开始日期：">
                {{financingDetailData.fi__startDate|moment('YYYY-MM-DD')}}
              </el-form-item>
              <el-form-item label="提款申请时间：">
                {{financingDetailData.fi__applicationDate|moment('YYYY-MM-DD HH:mm:ss')}}
              </el-form-item>
              <el-form-item label="贷款利率：">
                {{financingDetailData.fi__interestRate}}% ({{financingDetailData.fi__interestType|Status2CN}})
              </el-form-item>
              <el-form-item label="利息收取节点：">
                {{financingDetailData.fi__interestPayTime}}
              </el-form-item>
              <el-form-item label="还款方式：">
                {{financingDetailData.fi__repaymentFormula|repaymentFormula2CN  }}
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="贷款申请状态：">
                {{financingDetailData.fi__applicationStatus|Status2CN}}
              </el-form-item>
              <el-form-item label="客户手机号：">
                {{financingDetailData.i__contactTelNo}}
              </el-form-item>
              <el-form-item label="贷款产品：">
                {{financingDetailData.ct__productName}}
              </el-form-item>
              <el-form-item label="币别：">
                {{financingDetailData.pi__currencyCode||'人民币'}}
              </el-form-item>
              <el-form-item label="贷款结束日期：">
                {{financingDetailData.fi__endDate|moment('YYYY-MM-DD')}}
              </el-form-item>
              <el-form-item label="贷款比例：">
                {{financingDetailData.ct__financingRatio}}%
              </el-form-item>
              <el-form-item label="贷款费率：">
                {{financingDetailData.fi__lendingFee|formatMoney}}{{financingDetailData.fi__lendingFeeType=='Rate' ? '%' : '元'}}
              </el-form-item>
              <el-form-item label="费用收取节点：">
                {{financingDetailData.fi__lendingFeePayTime}}
              </el-form-item>
              <el-form-item label="还款期数（月）：">
                {{financingDetailData.fi__repaymentCount}}
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="贷款用途：">
                {{financingDetailData.fi__intendedUse}}
              </el-form-item>
            </el-col>
          </panel>
        </el-row>
      </el-form>
      <panel label="审核结果" v-if="approverTableData.data.length>0">
        <data-table
          :table-data="approverTableData"
          :columns="approverTableColumns"
          :is-pagination-show="false"
        />
      </panel>
     <!-- <panel title="应收账款列表">
        <invoices-data-table :invoices="financingDetailData.invoices" :columns="invoiceColumns"></invoices-data-table>
      </panel>-->
      <panel title="附件列表">
        <files-data-table :files="financingDetailData.files"></files-data-table>
      </panel>
      <el-dialog title="查看还款计划" :visible.sync="repaymentDialogVisible">
        <repay-plan-data-table :data="repaymentPlanList"></repay-plan-data-table>
      </el-dialog>
    </div>
</template>

<script>
  import Panel from '../../components/Panel'
  import DataTable from '../../components/DataTable'
  import InvoicesDataTable from './InvoicesDataTable'
  import FilesDataTable from '../../components/FilesDataTable'
  import RepayPlanDataTable from './RepayPlanDataTable'
  import repaymentFormulaOptions from '../../utils/repaymentFormulaOptions'
  import moment from 'moment'
  import Status2CN from "../../filters/Status2CN"
  import FinancingApplyingFormComponent from "./FinancingApplyingFormComponent";

  export default {
    name: "FinancingApplyingDetailComponent",
    data() {
      return {
        repaymentDialogVisible: false,
        invoiceColumns: [
          {
            name: '单据类型',
            field: 'pi__invoiceType'
          },
          {
            name: '单据号码',
            field: 'pi__invoiceNo'
          },
          {
            name: '单据金额',
            field: 'pi__totalAmount',
          },
          {
            name: '质押金额',
            field: 'pi__pledgeAmount'
          },
          {
            name: '币种',
            field: 'pi__currencyCode',
            formatter: function(r,c,v) {
              return '人民币'
            }
          },
          {
            name: '单据日期',
            field: 'pi__invoiceDate',
          },
          {
            name: '到期日',
            field: 'pi__dueDate',
          },
          {
            name: '本次贷款金额',
            field: 'pi__financingAmount',
          },
        ]
      }
    },
    props: {
      repaymentPlanList: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      financingDetailData : {
        type: Object,
        default: ()=>{
          return {
            invoices:[],
            files:[],
            detail: []
          }
        }
      }
    },
    components: {
      FinancingApplyingFormComponent,
      Panel,
      InvoicesDataTable,
      RepayPlanDataTable,
      FilesDataTable,
      DataTable
    },
    computed: {
      approverTableData() {
        return {
          data: this.financingDetailData.detail.filter(item=>item.a__approvingDate)
        }
      },
      approverTableColumns() {
        return [
          {
            label: '审核人',
            field: 'a__approverName',
          },
          {
            label: '审核结果',
            field: 'a__approvingStatus',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '备注',
            field: 'a__remarks'
          },
          {
            label: '审核时间',
            field: 'a__approvingDate',
            formatter: function (r,c,v) {
              return moment(v).format('YYYY-MM-DD HH:mm:ss')
            }
          }
        ]
      }
    },
    filters: {
      repaymentFormula2CN: function (val) {
        if(val) {
          let repaymentFormula = (repaymentFormulaOptions.filter(item=>item.value==val)).shift()
          if(repaymentFormula)
            return repaymentFormula.label
          else return val
        }
        else return val
      },
      Status2CN
    },
    methods: {
      viewRepayPlay: function () {
        this.repaymentDialogVisible = true
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/FinancingApplyingDetailComponent.vue